import { defineStore } from 'pinia';
import { KDSRegisters } from '@/services/endpoint/kds.service';

export const useKDSStore = defineStore('kds', {
  state: () => ({
    name: null,
    id: null,
    branchId: null,
    stationId: null,      // null = ทุกหมวด (All)
    stationName: null,
    stationColor: null,
    categoryIds: [],       // [] = ไม่กรอง (All)
    loggedIn: false
  }),
  actions: {
    async enterKds(branchId, stationId = null) {
      try {
        const res = await KDSRegisters.enterKds(branchId, stationId);
        const data = res.data.data;
        this.loggedIn = true;
        this.name = data.branch_name ?? data.name;
        this.id = data.id;
        this.branchId = branchId;
        this.stationId = data.station?.id ?? null;
        this.stationName = data.station?.name ?? null;
        this.stationColor = data.station?.color ?? null;
        this.categoryIds = data.station?.category_ids ?? [];
        return res;
      } catch (err) {
        this.$reset();
        throw err;
      }
    },
    outShop() {
      this.$reset();
    },
    clearShopState() {
      this.$reset();
    }
  },
  persist: true
});
